export const customerPanDetailsFormFields = [
  {
    type: 'text',
    name: 'panNumber',
    label: 'PAN number',
    placeholder: 'Enter Valid PAN Number',
    example: 'E.g. NVLNK4546Q',
    maxLength: 10,
    autoCapitalize: 'characters',
    config: {
      required: true,
    },
  },
  {
    type: 'date',
    name: 'dob',
    label: 'Date of birth',
    example: 'E.g. 20/02/1996',
    value: new Date(),
    config: {
      required: true,
      maxDate: new Date(),
    },
  },
]
